// Sitecore validates image ratio with a measurement error +/-1px
// matchRatio allows to check if the measurement error is in the valid range

function matchRatio ({ ratioWidth, ratioHeight, width, height, measurementError }) {
  const preciseHeight = Math.ceil((width / ratioWidth) * ratioHeight)
  return Math.abs(preciseHeight - height) <= measurementError
}

export default matchRatio
